import React from 'react';
import { TextInput, TextArea, CardList, SectionHeader, Field } from './Fields';

const ResultadosEditor = ({ data, onChange }) => {
  const set = (key, val) => onChange({ ...data, [key]: val });

  return (
    <div>
      <SectionHeader title="Seção Resultados" />
      <TextInput label="Título" value={data.heading} onChange={v => set('heading', v)} />
      <TextArea label="Subtítulo" value={data.subheading} onChange={v => set('subheading', v)} />

      <CardList
        label="Estatísticas"
        value={data.stats}
        onChange={v => set('stats', v)}
        emptyCard={{ end: 0, prefix: '', suffix: '%', label: '' }}
        renderCard={(item, i, update) => (
          <div className="grid grid-cols-2 gap-2">
            <Field label="Número final">
              <input
                type="number"
                value={item.end}
                onChange={e => update({ end: parseInt(e.target.value, 10) || 0 })}
                className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </Field>
            <TextInput label="Sufixo" value={item.suffix} onChange={v => update({ suffix: v })} placeholder="%" />
            <TextInput label="Prefixo" value={item.prefix} onChange={v => update({ prefix: v })} placeholder="+" />
            <TextInput label="Descrição" value={item.label} onChange={v => update({ label: v })} />
          </div>
        )}
      />
    </div>
  );
};

export default ResultadosEditor;
